<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Statement Print",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      title: "Insurance Company Statement",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Print Statement",
          active: true,
        },
      ],
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
      name: atob(this.$route.params.name),
      from: atob(this.$route.params.from),
      to: atob(this.$route.params.to),
      data: {
        id: atob(this.$route.params.id),
        from: atob(this.$route.params.from),
        to: atob(this.$route.params.to),
      },
    };
  },
  computed: {
    ...mapGetters("insurance", ["Statement"]),
  },
  methods: {
    ...mapActions({
      FetchStatement: "insurance/fetchStatement",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  // updated() {
  //   setTimeout(() => {
  //     window.print();
  //   }, 1000);
  // },
  created() {
    this.FetchStatement(this.data);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Verdana, Geneva, sans-serif;
}
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
        <div class="bg-white p-2">
          <div class="print-font mt-4">
            <table width="100%" class="mt-3">
              <b-spinner
                v-if="!Statement"
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner>
              <tr v-else>
                <td width="50%">
                  <img
                    :src="Statement.clinic ? Statement.clinic.clinicLogo : '#'"
                    alt="Logo"
                    height="100"
                  />
                </td>

                <td width="50%" style="text-align: right; padding-right: 15px !important">
                  <strong style="font-size: calc(1.2671875rem + 0.20625vw)">
                    {{ Statement.clinic ? Statement.clinic.clinicName : "---" }}</strong
                  >
                  <p>
                    <span
                      v-html="Statement.clinic ? Statement.clinic.clinicAddress : '---'"
                    ></span>
                    <br />
                    <strong>Tel: </strong>
                    {{ Statement.clinic ? Statement.clinic.clinicContact : "---" }}
                    <br />
                    <strong>Email: </strong
                    >{{ Statement.clinic ? Statement.clinic.clinicMail : "---" }}
                  </p>
                </td>
              </tr>
            </table>
            <hr style="border-style: dashed; width: 97%" />
            <table width="50%">
              <b>Insurance Company Details</b>
              <tr>
                <td>
                  To: _____________________________________ <br />
                  {{ Statement.clinic ? Statement.company.name : "--" }} -
                  {{ Statement.clinic ? Statement.company.email : "--" }} -
                  {{ Statement.clinic ? Statement.company.contact : "--" }}
                </td>
              </tr>
            </table>
            <hr />

            <div width="100%">
              <!-- <h5>Items Bought</h5> -->
              <table width="100%" style="margin-bottom: -12px">
                <tr>
                  <td width="70%"></td>
                  <td width="30%">
                    <table width="100%" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Amount Due</th>
                          <th>Amount Enc.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ Statement.clinic ? Statement.due_amt : "---" }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </table>
              <table width="100%" class="table table-bordered" style="font-size: 15px">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Transaction</th>
                    <th>Amount</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record, r) in Statement.invoice ? Statement.invoice : []"
                    :key="r"
                  >
                    <td>{{ record.date }}</td>
                    <td>{{ record.transaction }}</td>
                    <td>{{ record.amount }}</td>
                    <td>{{ record.balance }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table width="100%">
              <tr>
                <td width="50%">Accounts are due on demand</td>
                <td width="50%">
                  Prepared by:
                  <strong>{{ Statement.clinic ? Statement.user.name : "---" }}</strong
                  ><br />
                  For and on behalf of:
                  <strong>{{
                    Statement.clinic ? Statement.clinic.clinicName : "---"
                  }}</strong>
                </td>
              </tr>
            </table>
            <table width="100%" style="font-size: 15px">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Provider</th>
                  <th>Number</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(mode, m) in Statement.paymode ? Statement.paymode : []"
                  :key="m"
                >
                  <td>{{ mode.mode_name }}</td>
                  <td>{{ mode.provider }}</td>
                  <td>{{ mode.mode_number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
